"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToUnix = dateToUnix;
exports.unixToDate = unixToDate;
exports.isEarlierThanNow = isEarlierThanNow;
exports.daysAgo = daysAgo;
exports.prepareDateForDb = prepareDateForDb;
function dateToUnix(date) {
    if (!date)
        return Math.floor(new Date().getTime());
    return Math.floor(new Date(date).getTime());
}
function unixToDate(epoch) {
    if (!epoch)
        return new Date();
    return new Date(new Date(epoch).getTime());
}
function isEarlierThanNow(startTime) {
    if (!startTime)
        return true;
    if (startTime <= new Date())
        return true;
    return false;
}
function daysAgo(days) {
    const today = new Date();
    return new Date(new Date().setDate(today.getDate() - days));
}
function prepareDateForDb(date) {
    return new Date(date).toISOString();
}
//# sourceMappingURL=datetime.js.map